// extracted by mini-css-extract-plugin
export default {"chart":"chart-card_chart__srHEv","chart__title":"chart-card_chart__title__w4sUf"};